// 快船 Logo — 使用 🚤 emoji 作为占位，Phase 4 后期会替换为 text_to_image 生成的 PNG
// (避免在编译期阻塞，等用户确定域名/品牌色后再生成)

import { APP_NAME } from '@kuaichuan/shared';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  withText?: boolean;
  className?: string;
}

const SIZES = {
  sm: 'text-2xl',
  md: 'text-4xl',
  lg: 'text-6xl',
  xl: 'text-8xl',
};

export function Logo({ size = 'md', withText = false, className = '' }: LogoProps) {
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <div
        className={`${SIZES[size]} leading-none select-none`}
        role="img"
        aria-label={APP_NAME}
      >
        🚤
      </div>
      {withText && (
        <span className="font-bold text-ink" style={{ fontSize: size === 'xl' ? 32 : size === 'lg' ? 24 : 18 }}>
          {APP_NAME}
        </span>
      )}
    </div>
  );
}
